/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nHead.vue?vue&type=template&id=50ab3b05&scoped=true"
import script from "./nHead.vue?vue&type=script&lang=js"
export * from "./nHead.vue?vue&type=script&lang=js"
import style0 from "./nHead.vue?vue&type=style&index=0&id=50ab3b05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab3b05",
  null
  
)

export default component.exports